import axiosInstance from "../lib/axiosInstance";


const Baseurl = process.env.REACT_APP_API_URL


const orderModel = class {

    async PlaceOrder(data=[]) {
        return await axiosInstance.post(Baseurl +"/orders/place_order",data);
    }
    async UpdateOrder(id, data=[]) {
        return await axiosInstance.put(Baseurl +`/orders/${id}`,data);
    }
    async GetOrders(params) {
        return await axiosInstance.get(Baseurl + "/orders", { params });
      }
    async GetOrdersDetail(id) {
        return await axiosInstance.get(Baseurl +`/orders/${id}`);
    }
}

export default new orderModel();